
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.29288 18.7071L7.87866 17.2929L13.1716 12L7.87866 6.70711L9.29287 5.29289L16 12L9.29288 18.7071Z" fill="currentColor"></path></svg>';export default svg;
    